export default __webpack_public_path__ + "static/media/experience-tour_choices-video.c5342028.jpg";